namespace GeniuzPOS.Administration {
    export interface PsFuncLevelForm {
        FunLevel: Serenity.IntegerEditor;
        FunLevelName: Serenity.StringEditor;
    }

    export class PsFuncLevelForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.PsFuncLevel';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsFuncLevelForm.init)  {
                PsFuncLevelForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;

                Q.initFormType(PsFuncLevelForm, [
                    'FunLevel', w0,
                    'FunLevelName', w1
                ]);
            }
        }
    }
}
